import {relativeLuminance} from '@app/lui2/utils/color';
import Luiv3Constants, {LuiV3ColorKey} from '@app/lui3/constants';
import styled, {css} from 'styled-components';

const LIGHT_CONTENT_LUMINANCE = 0.7;

interface Props {
  disabled: boolean;
  contentColor?: LuiV3ColorKey;
}

const BaseContentLayer = styled.div<Props>`
  --badge-default-size: 1rem;
  ${({disabled, contentColor}) => {
    const resolved = contentColor && Luiv3Constants.baseColor[contentColor];
    return (
      disabled &&
      resolved &&
      relativeLuminance(resolved) < LIGHT_CONTENT_LUMINANCE &&
      css`
        opacity: 0.38;
      `
    );
  }}
`;

export default BaseContentLayer;
